// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Blog-module--wrap--3BVW7","container":"Blog-module--container--1qOlx","header":"Blog-module--header--2-lPO","post":"Blog-module--post--1qKXL"};